import { Boxes, FileText, Handshake, Percent, type LucideIcon } from "lucide-react";

type Bullet = { Icon: LucideIcon; title: string; body: string };

const BULLETS: Bullet[] = [
  {
    Icon: FileText,
    title: "Document & mailpiece design",
    body:
      "Layouts, address-window placement, IMb barcodes, structured-data mailings, print-ready PDFs.",
  },
  {
    Icon: Boxes,
    title: "File Based Processing & inserter workflows",
    body:
      "FBP rollouts and support for production insertion equipment, plus reconciliation that actually matches.",
  },
  {
    Icon: Percent,
    title: "Postage, presort & discount optimization",
    body:
      "We know the postal offerings and presort options that put real dollars back into your mail budget.",
  },
  {
    Icon: Handshake,
    title: "Vendor & equipment coordination",
    body:
      "We speak the technical language of Pitney Bowes, BlueCrest, BCC, PlanetPress / Objectif Lune, OPEX, Kodak, and others.",
  },
];

// Realistic 65-bar IMb mock — same heights as the static version, kept here so
// the envelope visual stays self-contained.
const BAR_HEIGHTS = [
  22, 14, 18, 22, 14, 8, 18, 22, 14, 22, 8, 18, 22, 14, 18, 8, 22, 18, 14, 22,
  8, 18, 22, 14, 22, 18, 14, 8, 22, 14, 18, 22, 8, 18, 14, 22, 18, 14, 22, 8,
  18, 22, 14, 18, 22, 8, 14, 22, 18, 14, 22, 18, 8, 22, 14, 18, 22, 14, 18, 22,
  8, 14, 18, 22, 14,
];

export function Mail() {
  return (
    <section className="section mail" id="mail">
      <div className="container">
        <div className="mail-grid">
          <div className="reveal">
            <span className="eyebrow">Print, mail &amp; document automation</span>
            <h2
              className="t-h2"
              style={{ margin: "12px 0 16px", fontSize: "clamp(32px,3.4vw,44px)" }}
            >
              From data to document
              <br />
              to <em>postal stream.</em>
            </h2>
            <p className="t-lead" style={{ margin: 0, fontSize: 17 }}>
              Production mail isn't "send a PDF to a printer." We design
              documents, structure the data, coordinate vendors, optimize for
              postal discounts, and build the workflows that move mail reliably —
              every job, every cycle.
            </p>

            <div className="mail-bullets">
              {BULLETS.map((b) => (
                <div className="mail-bullet" key={b.title}>
                  <div className="mail-bullet-icon">
                    <b.Icon size={18} />
                  </div>
                  <div>
                    <h4>{b.title}</h4>
                    <p>{b.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal">
            <div className="envelope" aria-hidden>
              <span className="envelope-tag">#10 · WINDOW · IMB</span>
              <div className="stamp">
                USPS
                <br />
                FIRST CLASS
              </div>
              <div className="addr">
                JANE DOE
                <br />
                123 RIDGE RD
                <br />
                ASHEVILLE NC 28801-1234
              </div>
              <div className="barcode">
                {BAR_HEIGHTS.map((h, i) => (
                  <span key={i} style={{ height: h }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
